import React, { Component } from 'react';
import _ from 'lodash';
import * as QuizHelpers from '../../helpers/quiz';

class Budget extends Component {
  state = {
    animate: ''
  }

  constructor (props) {
    super(props);
    // Skip Budget If ChildrenOnly
    if (props.quiz.fieldValues.FamilyType === 'ChildrenOnly') {
      props.stepMethods.nextStep();
    }
  }

  componentDidMount () {
    const p = _.clone(this.props);
    QuizHelpers.sendAnalyticsOnQuestion(`${p.route}`, 'Budget Preference');
    setTimeout(() => {
      this.setState({
        animate: 'fadeIn'
      });
    }, 600);
  }

  _handleSelectBudget (val) {
    const {quiz, stepMethods} = _.clone(this.props);
    let nextStep;

    if (quiz.fieldValues.Essential === false && quiz.fieldValues.Medicaid === false && quiz.fieldValues.Medicare === false) {
      nextStep = quiz.step + 1;
    } else if (quiz.fieldValues.Location.loc.IsWesternNY === true && quiz.fieldValues.Medicare === true) {
      // alert('WESTERN');
      nextStep = quiz.step + 6;
    } else if (quiz.fieldValues.Medicare === true) {
      // alert('JUST MEDICARE');
      nextStep = quiz.step + 5;
    } else if (quiz.fieldValues.Essential === true && quiz.fieldValues.Medicaid === true) {
      nextStep = quiz.step + 4;
    } else if (quiz.fieldValues.Essential === false && quiz.fieldValues.Medicaid === true) {
      nextStep = quiz.step + 3;
    } else {
      nextStep = quiz.step + 1;
    }

    this.props.reducer(val);
    stepMethods.setStep(nextStep);
  }

  _prevStep () {
    window.history.go(-1);
  }

  render () {
    return (
      <section className={'p30 text-center animate ' + this.state.animate}>
        <div className='wrap'>
          <h3>Which is more important to you &ndash; a lower monthly premium or lower costs when you receive health care?</h3>
          <div className='radio two form'>
            <input type='radio' name='budget' value='high'
              id='high'
            /><label htmlFor='high'
              onClick={(e) => (this._handleSelectBudget(1))}>Lower premium</label>
            <input type='radio' name='budget' value='low'
              id='low'
            /><label
              htmlFor='low'
              onClick={(e) => (this._handleSelectBudget(2))}>Lower costs</label>
            <button className='btn back' onClick={this._prevStep}>Previous</button>
          </div>
        </div>
      </section>
    );
  }
}

export default Budget;
